var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRedGraphL(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 48,
    viewBox: "0 0 95 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M93.0714 22.1705C88.3127 18.3557 85.6447 16.2169 80.886 12.4021C76.1273 8.58736 68.7077 22.6079 59.5615 22.1705C51.2704 21.774 48.8355 13.9181 40.6741 12.4021C35.5272 11.4461 32.3256 13.7623 27.2701 12.4021C20.5116 10.5838 19.4452 3.68876 12.6476 2.02325C8.25617 0.947291 1.07141 2.02325 1.07141 2.02325",
    stroke: "#DB3F40",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M80.886 14.2644L93.0714 24.161V47.9749H1.07141V3.74913C1.07141 3.74913 8.25616 2.65904 12.6476 3.74913C19.4452 5.43653 20.5116 12.4222 27.2701 14.2644C32.3256 15.6423 35.5272 13.2958 40.6741 14.2644C48.8355 15.8002 51.2704 23.7593 59.5615 24.161C68.7077 24.6042 76.1273 10.3995 80.886 14.2644Z",
    fill: "url(#paint0_linear_193_728)",
    fillOpacity: 0.8
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_193_728",
    x1: 47.0714,
    y1: 3.26465,
    x2: 47.0714,
    y2: 47.9749,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.291667,
    stopColor: "#FEF5EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.822917,
    stopColor: "#FEF5EE",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedGraphL);
export default __webpack_public_path__ + "static/media/redGraphL.39dfc8f268483f87c20fdf9a5f9b19e9.svg";
export { ForwardRef as ReactComponent };